module.exports = __webpack_public_path__ + "media/application/images/footer/instagram-a63e17f150464fe47412609c04aa3f94.svg";